import React, { Component } from 'react';
import { Modal, Row, Col } from 'antd';
import ReactToPrint from "react-to-print";
import { getUsuario } from "../utils/LoginManager";
import "../relatorios/Relatorios.css";
import moment from "moment-timezone"; // VALIDAR DATAS
import { resolveImageUrl } from '../utils/Storage';
import Colors from '../utils/Colors';

export default class PrintModal extends Component {

    renderDataAtual = () => {
        return moment().format("DD/MM/YYYY HH:mm");
    }

    render() {
        const { children, width, ...outrasProps } = this.props;
        const usuario = getUsuario();

        // console.log('PrintModal: ', usuario)

        return (
            <Modal {...outrasProps}
                footer={null}
                width={width ? width : 900}
                destroyOnClose
                style={{ top: 20 }}
            >
                <div>

                    <ReactToPrint
                        trigger={() => (
                            <a className="ant-btn ant-btn-primary" style={{ backgroundColor: Colors.primaryDark, borderColor: Colors.primary }}>
                                Imprimir
                            </a>
                        )}
                        content={() => this.componentRef}
                        pageStyle={{ margin: 50 }}
                    />

                    <hr />

                    <div
                        style={{ height: 500, overflow: 'auto' }}
                    >

                        <div ref={el => (this.componentRef = el)}>

                            <Row>
                                {usuario.emp_logo ? (
                                    <div style={{ float: "right", marginTop: 25, marginRight: 30 }}>
                                        <img
                                            src={usuario.emp_logo ? resolveImageUrl(`emp${usuario.emp_codigo}/${usuario.emp_logo}`) : ''}
                                            resizeMode="contain"
                                            style={{ height: 80, width: 80 }}
                                        />
                                    </div>
                                ) : null}

                                <div style={{ float: "left", marginTop: 30, marginLeft: 30 }}>
                                    <div>
                                        <span className="nome-empresa">
                                            {usuario.emp_nome}
                                        </span>
                                    </div>
                                    <div>
                                        <span className="dados-empresa">
                                            {usuario.emp_cpf_cnpj ? usuario.emp_cpf_cnpj : ''}
                                            {usuario.emp_fone1 ? ' - ' + usuario.emp_fone1 : ''}
                                            {usuario.emp_fone2 ? ' - ' + usuario.emp_fone2 : ''}
                                            {usuario.emp_fone3 ? ' - ' + usuario.emp_fone3 : ''}
                                        </span>
                                    </div>
                                    <div>
                                        <span className="dados-empresa">
                                            {usuario.emp_endereco ? usuario.emp_endereco : ''}
                                            {usuario.emp_numero ? ' nº ' + usuario.emp_numero : ''}
                                            {usuario.emp_complemento ? ' ' + usuario.emp_complemento : ''}
                                            {usuario.emp_bairro ? ' - ' + usuario.emp_bairro : ''}
                                            {usuario.cmun_descricao ? ' - ' + usuario.cmun_descricao : ''}
                                            {usuario.cuf_sigla ? ' - ' + usuario.cuf_sigla : ''}
                                        </span>
                                    </div>
                                </div>
                            </Row>

                            <Row>
                                {children}
                            </Row>

                            <Row xs={24}>
                                <span className="cab-data">
                                    P7Vendas - {this.renderDataAtual()}
                                </span>
                            </Row>
                        </div>

                    </div>
                </div>
            </Modal >
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/PrintModal.js